import { PopoverDesignTokens } from '@primeng/themes/types/popover';

export const basePopoverToken: PopoverDesignTokens = {
  root: {
    //   background: '{overlay.popover.background}',
    borderColor: 'unset',
    color: '{gray.600}',
    borderRadius: '0 0 0.25rem 0.25rem',
    shadow: '0rem 0.5rem 1rem 0rem #00000026',
    gutter: '0.5625rem',
    //   arrowOffset: '1.25rem',
  },
  content: {
    padding: '0',
  },
};
